import React from 'react';
import { Box } from '@material-ui/core';

/**
 * Section Container Component
 * Generic wrapper with semantic HTML section element and styling props
 */
const Section = ({ children, title, padding = 0, margin = 0, style, ...props }) => (
  <Box
    component="section"
    style={{
      padding: padding ? `${padding}px` : 0,
      margin: margin ? `${margin}px` : 0,
      width: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      ...style,
    }}
    {...props}
  >
    {title && (
      <Box
        mb={2}
        fontWeight="bold"
        fontSize="1.1rem"
        color="text.primary"
      >
        {title}
      </Box>
    )}
    {children}
  </Box>
);

export default Section;
